module.exports = __webpack_public_path__ + "static/img/4.d758083.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/4/1/sp/4.png
// module id = js34
// module chunks = 0